module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Buttisholz-9ad025dc2724006cc017d12a478584d1.svg";